module.exports = __webpack_public_path__ + "img/B561.3b7b8be1.jpg";